import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { RegexEnum } from 'src/app/shared/global/regex-enum';
import { AppService } from 'src/app/shared/services/auth-service/login-emitter.service';
import { ResetPassword } from 'src/app/shared/services/auth-service/reset-password.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
    linkExpired = false;
    apiResponse: any[] = [];
    form!: FormGroup;
    eMail!: string;
    message: any;
    private sub = new Subject<void>();
    userDoesNotExist = false;
    epochNow!: number;
    subscription: Subscription;
    constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private appService: AppService,
    private passwordReset: ResetPassword,
    private toastrService: ToastrService
    ) {}
    count: any;
    ngOnInit(): void {
        this.form = this.formBuilder.group({
            emailFormControl: [
                '',
                [
                    Validators.required,
                    Validators.minLength(5),
                    Validators.pattern(RegexEnum.email),
                ],
            ],
            recaptcha:['', [Validators.required]]
        });
        this.subscription = this.appService.userEmail.subscribe((c) => {
            this.count = c;
        });
        this.epochNow = new Date().getTime();
    }
    async submit() {
        if (this.form.valid) {
            this.eMail = this.form.controls['emailFormControl'].value;
            const recaptcha = this.form.controls['recaptcha'].value || null;
            this.appService.getEmail(this.eMail);
    
            try {
                const data = await this.passwordReset.resetPwd(this.eMail, recaptcha,this.epochNow);
                this.router.navigate(['/reset_link_sent']);
              
            } catch (error:any) {
                    if (error?.error?.code == 400) {
                        this.form.controls['emailFormControl'].setErrors({
                            userDoesNotExist: true,
                        });
                    }else if(error?.error?.code == 429){
                        this.form.controls['emailFormControl'].setErrors({
                            IPError: true,
                        });
                    }else if(error?.status == 404){
                        this.toastrService.error(error?.error?.message);
                    }
            }
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    addTokenLog(message: string, token: string | null) {
        this.form.controls['recaptcha'].setValue(token);
    }

    public formatToken(token: string | null) {
        return token !== null
            ? `${token.substring(0, 7)}...${token.substring(-7)}`
            : 'null';
    }
}
